var HOST = 'd1lzx9fkb1m9tb.cloudfront.net';

var Q = require('q'),
	$ = require('jquery'),
	config = require('core/config');

function drupalPageService(url) {
	if (url[0] !== '/') {
		url = '/' + url;
	}

	var deferred = Q.defer();

	$.get('//' + HOST + encodeURI(url).replace(/%/g, '%25')).then(function (result) {
		deferred.resolve(
			result
				.replace('UA-18335380-1', config.google && config.google.analytics)
				.replace('"url": "http:\\/\\/www.readworks.org', '"url": "//' + HOST)
				.replace(/src="\//g, 'src="//' + HOST + '/')
				.replace(/rel="stylesheet" href="http:\/\/www\.readworks\.org/g, 'rel="stylesheet" href="//' + HOST)
				.replace(/http:\/\/fonts.googleapis.com\/css\?family=Arvo/g, '//fonts.googleapis.com/css?family=Arvo')
				.replace(/img src="http:\/\/www\.readworks\.org/g, 'img src="//' + HOST)
		);
	}, deferred.reject);

	return deferred.promise;
}

drupalPageService.HOST = HOST;

module.exports = drupalPageService;
